export default __webpack_public_path__ + "static/media/Lato-LightItalic.e988b7f0.woff2";